import { useQuery } from '@tanstack/react-query'
import { productAPI, featuredProductAPI } from '../../api'

// Query key factory for options (long-lived cached data)
export const optionKeys = {
  all: ['options'] as const,
  product: () => [...optionKeys.all, 'product'] as const,
  featuredProduct: () => [...optionKeys.all, 'featuredProduct'] as const,
}

// Fetch product options (categories, manufacturers, colors, sizes)
// These change infrequently so we cache them for 30 minutes
export function useProductOptions() {
  return useQuery({
    queryKey: optionKeys.product(),
    queryFn: () => productAPI.getOptions(),
  })
}

// Fetch featured product options (categories, products list)
// Products list may change more frequently, so shorter cache
export function useFeaturedProductOptions() {
  return useQuery({
    queryKey: optionKeys.featuredProduct(),
    queryFn: () => featuredProductAPI.getOptions(),
    // Cache for 10 minutes (products may be added/updated)
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  })
}
